import SectionHeading from '@/components/base/SectionHeading';
import { PARTICIPATION_STEPS } from '@/mocks/arrangement';

export default function StepsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50" aria-labelledby="steps-heading">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          id="steps-heading"
          eyebrow="How To Join"
          title="参赛只需四步"
          desc="报名、提交、初审、公投，每一步都在时间表上有对应的时间窗口，照着走就不会乱。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PARTICIPATION_STEPS.map((s) => (
            <article key={s.index} className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-6">
              <span className="font-heading text-4xl font-bold text-primary-200">{s.index}</span>
              <h3 className="mt-3 font-heading text-lg font-semibold text-foreground-950">{s.title}</h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{s.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}